module.exports = __webpack_public_path__ + "static/media/residence.b4f785bb.svg";